import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Helmet } from 'react-helmet';
import removeAnimationClass from 'utils/Animations';
import SiteNavBMobileLevelA from 'components/SiteNav/SiteNavB/SiteNavBMobile/SiteNavBMobileLevelA';
import SiteNavBMobileLevelB from 'components/SiteNav/SiteNavB/SiteNavBMobile/SiteNavBMobileLevelB';
import SiteNavBMobileLevelC from 'components/SiteNav/SiteNavB/SiteNavBMobile/SiteNavBMobileLevelC';
import SiteNavBMobileLevelD from 'components/SiteNav/SiteNavB/SiteNavBMobile/SiteNavBMobileLevelD';
import SiteNavBMobileFlyout from 'components/SiteNav/SiteNavB/SiteNavBMobile/SiteNavBMobileFlyout';
import classes from './SiteNavBMobile.module.scss';

const SiteNavBMobile = (props) => {
  const {
    mainNavItems = [],
    globalNavLinks = [],
    button = {},
    contactHref,
    ...rest
  } = props;

  const [isMenuOpen, setIsMenuOpen] = useState();
  const [forceMenuNoAnimation, setforceMenuNoAnimation] = useState(true);
  const [levelBSelectedItem, setLevelBSelectedItem] = useState({});
  const [levelCSelectedItem, setLevelCSelectedItem] = useState({});
  const [showLevelC, setShowLevelC] = useState(false);
  const [showLevelD, setShowLevelD] = useState(false);
  const [animateLevelC, setAnimateLevelC] = useState(false);
  const [animateLevelD, setAnimateLevelD] = useState(false);

  const menuRef = useRef(null);

  const onMenuClick = () => {
    const show = !isMenuOpen;
    setIsMenuOpen(show);
    setforceMenuNoAnimation(false);
  };

  const getMenuClass = () => {
    if (forceMenuNoAnimation) {
      return classes.menuStayUp;
    }

    return isMenuOpen ? classes.menuDown : classes.menuUp;
  };

  return ([
    <Helmet key='helmet'>
      {/* disabling the lang req in case it was set by sitefinity - we don't want to override it */}
      {/* eslint-disable-next-line jsx-a11y/html-has-lang */}
      <html className={isMenuOpen && classes.noScroll} />
    </Helmet>,
    <div key='menu' className={classes.container}>
      <SiteNavBMobileLevelA
        isMenuOpen={isMenuOpen}
        onMenuClick={onMenuClick}
        {...rest}
      />
      <div
        aria-label='menu'
        ref={menuRef}
        className={getMenuClass()}
        onAnimationEnd={() => {
          removeAnimationClass(
            menuRef,
            classes.menuDown,
            classes.menuStayDown,
            classes.menuUp,
            classes.menuStayUp,
          );

          if (!isMenuOpen) {
            setShowLevelC(false);
            setShowLevelD(false);
          }
        }}
      >
        <SiteNavBMobileLevelB
          scroll={isEmpty(levelBSelectedItem) && isEmpty(levelCSelectedItem)}
          mainNavItems={mainNavItems}
          globalNavLinks={globalNavLinks}
          signIn={button}
          contactHref={contactHref}
          onMenuItemClick={(navItem) => {
            const {
              items = [],
            } = navItem;

            // if there is only one child item go straight to level D
            if (items.length > 1) {
              setLevelBSelectedItem(navItem);
              setShowLevelC(true);
              setAnimateLevelC(true);
            } else {
              setLevelCSelectedItem(navItem);
              setShowLevelD(true);
              setAnimateLevelD(true);
            }
          }}
        />
        <SiteNavBMobileFlyout
          onBackClick={() => {
            setAnimateLevelC(true);
            setShowLevelC(false);
          }}
          onAnimationEnd={() => {
            setAnimateLevelC(false);
            if (!showLevelC) {
              setLevelBSelectedItem({});
            }
          }}
          scroll={showLevelC && !showLevelD}
          show={showLevelC}
          animate={animateLevelC}
        >
          <SiteNavBMobileLevelC
            {...levelBSelectedItem}
            onMenuItemClick={(navItem) => {
              setLevelCSelectedItem(navItem);
              setShowLevelD(true);
              setAnimateLevelD(true);
            }}
          />
        </SiteNavBMobileFlyout>
        <SiteNavBMobileFlyout
          onBackClick={() => {
            setAnimateLevelD(true);
            setShowLevelD(false);
          }}
          onAnimationEnd={() => {
            setAnimateLevelD(false);
            if (!showLevelD) {
              setLevelCSelectedItem({});
            }
          }}
          scroll={showLevelD}
          show={showLevelD}
          animate={animateLevelD}
        >
          <SiteNavBMobileLevelD
            {...levelCSelectedItem}
          />
        </SiteNavBMobileFlyout>
      </div>
    </div>,
  ]
  );
};

SiteNavBMobile.propTypes = {
  mainNavItems: PropTypes.array,
  globalNavLinks: PropTypes.array,
  button: PropTypes.object,
  contactHref: PropTypes.string,
};

export default SiteNavBMobile;
